// Libraries
import React from "react";
import { EditableInput, useObserver, useState } from "@shoothill/core";
import { Box, Button, Modal, Typography, Checkbox } from "@material-ui/core";
import styled from "styled-components";
import { RegisterUserViewModel } from "Views/Register/RegisterUserViewModel";
import { CheckboxSVG } from "Globals/Views/IconSVGs/CheckboxSVG";
import { CheckboxCheckedSVG } from "Globals/Views/IconSVGs/CheckboxCheckedSVG";
import NewApplicantRequestViewModel from "Globals/ViewModels/Admin/Modal/NewApplicantRequestViewModel";
import { runInAction } from "mobx";
import { theme } from "Globals/Styles/AppTheme";
import { RegistrationTypeEnum } from "Globals/Models/RegistrationTypeEnum";
import { CrossSVG } from "Globals/Views/IconSVGs/CrossSVG";

export const ModalBase: any = styled(Modal)`
    padding: 0px;
    margin: 10% auto;
    flex-direction: column;
    display: flex;
    max-width: 335px;

    .modalhead,
    .modalbody {
        padding: 10px 15px;
        background-color: rgba(255, 255, 255, 1);
        outline: none;
    }

    .modalhead {
        border-radius: 5px 5px 0px 0px;
        background-color: #007aff;
        color: white;

        h2 {
            margin: 0 auto;
            font-size: 1.8em;
            text-transform: uppercase;
            font-weight: 500;
        }
    }
    .modalbody {
        border-radius: 0px 0px 5px 5px;
        background-color: rgba(255, 255, 255, 1);
        outline: none;
    }
`;
export const ModelButtonsContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 40px;

    button {
        border-radius: 0px;
        display: flex;
        flex: 1 50%;
        color: white;
        background-color: ${theme.palette.hightownBlue.light};
        :hover {
            background-color: ${theme.palette.hightownBlue.light};
        }
    }
`;

interface IProps {
    isActive: boolean;
    confirmClose(confirm: boolean): void;
    onCancel(): void;
}

export const NewApplicantRequestModal: React.FC<IProps> = (props) => {
    const [viewModel] = useState(() => new NewApplicantRequestViewModel());
    return useObserver(() => (
        <>
            <ModalBase open={props.isActive} onClose={() => props.onCancel()}>
                <div>
                    <Box className="modalhead" style={{ width: "120%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography variant="h6">New applicant</Typography>
                        <div style={{ cursor: "pointer", marginTop: "5px" }} onClick={() => props.onCancel()}>
                            <CrossSVG />
                        </div>
                    </Box>
                    <Box className="modalbody" style={{ width: "120%" }}>
                        <Box className="content">
                            <Box marginTop="40px">
                                <EditableInput label="First name(s)" placeHolder="Enter name(s)" viewModel={viewModel} fieldName="firstName" shrink={true} />
                            </Box>

                            <Box marginTop="40px">
                                <EditableInput label="Surname(s)" placeHolder="Enter Surname(s)" viewModel={viewModel} fieldName="surname" shrink={true} />
                            </Box>
                            <Box marginTop="40px">
                                <EditableInput
                                    type="tel"
                                    label="Mobile telephone number"
                                    placeHolder="telephone number"
                                    viewModel={viewModel}
                                    fieldName="phoneNumber"
                                    shrink={true}
                                />
                            </Box>
                            <Box marginTop="40px">
                                <EditableInput type="email" label="Email address" placeHolder="Email address" viewModel={viewModel} fieldName="emailAddress" shrink={true} />
                            </Box>
                            <Box marginTop="30px" display="flex" alignItems="center">
                                <Checkbox
                                    checked={viewModel.sendEmail}
                                    onChange={(e) => viewModel.handleCheckboxChange(RegistrationTypeEnum.Email, e.target.checked)}
                                    icon={<CheckboxSVG />}
                                    checkedIcon={<CheckboxCheckedSVG />}
                                />
                                <Typography variant="body1" style={{ fontWeight: "bold", marginLeft: "10px" }}>
                                    Send email registration
                                </Typography>
                            </Box>
                            <Box marginTop="30px" display="flex" alignItems="center">
                                <Checkbox
                                    checked={viewModel.sendSMS}
                                    onChange={(e) => viewModel.handleCheckboxChange(RegistrationTypeEnum.SMS, e.target.checked)}
                                    icon={<CheckboxSVG />}
                                    checkedIcon={<CheckboxCheckedSVG />}
                                />
                                <Typography variant="body1" style={{ fontWeight: "bold", marginLeft: "10px" }}>
                                    Send SMS registration
                                </Typography>
                            </Box>
                        </Box>
                        {viewModel.errorMessage != "" && (
                            <Box marginTop="40px">
                                <span style={{ color: "red" }}>{viewModel.errorMessage}</span>
                            </Box>
                        )}
                        <ModelButtonsContainer>
                            <Button
                                onClick={async () => {
                                    let close = await viewModel.createNewApplicant();
                                    if (close == true) {
                                        props.confirmClose(true);
                                    }
                                }}
                            >
                                Create new applicant
                            </Button>
                        </ModelButtonsContainer>
                    </Box>
                </div>
            </ModalBase>
        </>
    ));
};
